import { CellClassRules, ICellRendererParams } from 'ag-grid-enterprise'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

const percentageFormatter = numberFormatter({
  suffix: '%',
  transformer: (val) => val * 100,
})

const boldCellRules = {
  ['font-medium']: (params) => {
    return params.node.level === -1
  },
} satisfies CellClassRules

const colDefs = createColDefs([
  {
    field: 'aggregation_label',
    headerName: 'Attribution',
    cellClassRules: boldCellRules,
    cellRenderer: (params: ICellRendererParams) => {
      return params?.node.level === -1 ? 'Total' : params.value
    },
  },
  {
    field: '1_month_attributions',
    headerName: '1m',
    valueFormatter: percentageFormatter,
    aggFunc: 'sum',
    cellClassRules: boldCellRules,
  },
  {
    field: '3_month_attributions',
    headerName: '3m',
    valueFormatter: percentageFormatter,
    aggFunc: 'sum',
    cellClassRules: boldCellRules,
  },
  {
    field: 'ytd_attributions',
    headerName: 'YTD',
    valueFormatter: percentageFormatter,
    aggFunc: 'sum',
    cellClassRules: boldCellRules,
  },
])

export interface BucketedAttributionsDiversifiersTableProps extends ICReportTablePrimitive {}

export const BucketedAttributionsDiversifiersTable: React.FC<
  BucketedAttributionsDiversifiersTableProps
> = ({ params, options }) => {
  const query = diversifiers.useBucketedAttributions(params)
  const data = query.data ?? []

  return (
    <CustomAgGrid
      loading={query.isLoading}
      rowData={data}
      columnDefs={colDefs}
      grandTotalRow={'bottom'}
      {...options}
    />
  )
}
